import useOnScreen from "../../components/UseOnScreen/UseOnScreen"; 
import TypingEffect from "../../components/Animation/TypingEffect";
import "../Services/Supervision.css";

const Supervision = () => {
    const [aboutRef, isVisible] = useOnScreen({ threshold: 0.5, once: true });
    const supervisionText = "A supervisão contribui para a prevenção do esgotamento, construção de saberes e estratégias coletivos e permite pensar a relação terapêutica.";

  return (
    <div id="supervision" className="" ref={aboutRef}>
      <div className="supervision-container">
        <div className="supervision-text">
                {isVisible ? (
                        <>
                            <TypingEffect
                                text={supervisionText}
                                speed={70}    
                                className="supervision-phrase"
                                />
                        </>
                    ) : (
                        <div className="placeholder-text">
                            <span className="supervision-phrase">{supervisionText}</span>
                        </div>
                    )}
        </div>
        <div className="supervision-second-text">
          <h1>Supervisão para ATs</h1>
          <span>
              Encontros semanais + encontro teórico mensal | Grupos pequenos | Online
              <br></br>
              <br></br>
              Na supervisão ofereço um espaço vivo de escuta, reflexão e formação contínua, pensado especialmente para quem deseja sustentar sua prática com base na ética e nos fundamentos da psicanálise.
              <br></br>
              Nos encontros semanais em grupo, você terá a oportunidade de discutir casos, compartilhar impasses e pensar possibilidades de imanejo.
              <br></br>
              No encontro teórico mensal aprofundamos os principais conceitos, articulando teoria e prática de modo acessível e aplicável ao cotidiano do acompanhamento.
          </span>
        </div>
      </div>
    </div>
  );
}

export default Supervision;
